<div class="container">
  <div class="row">
    <div class="col-auto">
      <div (click)="navigateTo('')" class="cursor-pointer">
        <img class="logo" src="../../../../assets/images/gilded-logo.png" />
      </div>
    </div>
    <div class="col pe-0">
      <div *ngIf="loginDisplay" class="d-none d-md-block">
        <app-desktop-navbar
          [activePage]="activePage"
          [isViewer]="isViewer"
          [isAdmin]="isAdmin"
          [isSuperAdmin]="isSuperAdmin"
          [isImageFound]="isImageFound"
          [username]="user?.name"
          [region]="region"
          [userImage]="userImage"
        ></app-desktop-navbar>
      </div>
      <div *ngIf="loginDisplay" class="d-block d-md-none hamburger">
        <app-mobile-navbar
          [activePage]="activePage"
          [isViewer]="isViewer"
          [isAdmin]="isAdmin"
          [isSuperAdmin]="isSuperAdmin"
          [isImageFound]="isImageFound"
          [username]="user?.name"
          [region]="region"
          [userImage]="userImage"
        ></app-mobile-navbar>
      </div>
      <ul
        *ngIf="!loginDisplay"
        class="list-group list-group-horizontal mt-5 float-end"
      >
        <li class="list-group-item border-0 menu-item" (click)="login()">
          SIGN IN
        </li>
      </ul>
    </div>
  </div>
</div>
<div class="dividing-line mt-4"></div>
